<template>
    <el-menu mode="vertical"  style="margin-top:48px;border-right:none;" unique-opened :default-active="$route.path" :collapse="isCollapse">
      <sidebar-item :routes='current_routers'></sidebar-item>
    </el-menu>
</template>


<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'current_routers',
      'sidebar'
    ]),
    isCollapse() {
      return false;
    }
  },
  watch: {
    current_routers() {
      console.info(1)
      console.info(this.current_routers)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?513b21f6